import { Fifth } from "../../components/buttons/Fifth";

const credits = [
  {
    title: "Crédito personal",
    description:
      "Desde $200.000 hasta $1.000.000 para emergencias, con plazos desde 7 hasta 38 días según disponibilidad de fechas, te lo aprobamos de inmediato.",
    button: "Solicitar ahora",
    href: "/",
  },
  {
    title: "Crédito a cuotas",
    description:
      "Montos desde $1.000.000 hasta $3.000.000 con plazos entre 3 y 6 cuotas, aplica solo para clientes que ya hayan tenido 1 crédito personal o más.",
    button: "Ya soy cliente",
    href: "#",
  },
  {
    title: "Crédito en físico",
    description:
      "Solicita hasta $1.000.000 de manera física, no tendrás acceso a los beneficios de Galilea y los tiempos entre estudio y desembolso pueden tardar 15 días hábiles.",
    button: "Tramitar ahora",
    href: "/fisico",
  },
];

export function CreditPage() {
  return (
    <div className="bg-red bg-opacity-10 overflow-hidden pt-10 font-walsheim">
      <div className="pt-6 pb-16 sm:pb-24">
        <main className="mt-16 sm:mt-18">
          <div className="mx-auto max-w-7xl">
            <div className="block">
              <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                <div>
                  <h1 className="mt-4 text-4xl tracking-tight font-bold sm:mt-5 sm:leading-none lg:my-14 lg:text-5xl xl:text-6xl">
                    <span className="md:block">
                      Galilea, distintas opciones de crédito.
                    </span>{" "}
                  </h1>
                </div>
              </div>

              <div className="lg:flex mt-0 px-2 sm:mt-24 lg:mt-0 lg:col-span-6">
                {credits.map((credit) => (
                  <div
                    key={credit.title}
                    className="bg-white content-between my-8 shadow-lg sm:w-full sm:mx-4 rounded-lg sm:overflow-hidden"
                  >
                    <div className="px-4 py-4 sm:px-10">
                      <div>
                        <h3 className="font-bold text-2xl">{credit.title}</h3>
                        <div className="pt-4">
                          <span className="">{credit.description}</span>
                        </div>
                        <div className="py-4 w-2/3">
                          <a href={credit.href}>
                            <Fifth text={credit.button} />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
